import React, { ReactNode } from 'react'
import styled from 'styled-components'

const Container = styled.div`
  display: inline-block;
  position: relative;
`

const DefaultSpan = styled.span<{ $isActive: boolean }>`
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  opacity: ${({ $isActive }) => ($isActive ? 0 : 1)};
  width: 100%;
`

const ActiveSpan = styled.span<{ $isActive: boolean }>`
  opacity: ${({ $isActive }) => ($isActive ? 1 : 0)};
  font-weight: 700;
`

export const BoldableText: React.FC<{
  $isActive: boolean
  children: ReactNode
}> = ({ $isActive, children }) => {
  return (
    <Container>
      <DefaultSpan $isActive={$isActive} aria-hidden={$isActive}>
        {children}
      </DefaultSpan>
      <ActiveSpan $isActive={$isActive} aria-hidden={!$isActive}>
        {children}
      </ActiveSpan>
    </Container>
  )
}
